<div class="col-12">
  <div class="text-center mb-3">
    <div class="m-5">
      <img src="assets/images/empty-illustration.svg" alt="" width="200px">
    </div>
    <span>Empty List</span>
  </div>
</div>
